export default __webpack_public_path__ + "static/media/healthCardImage.41da786a.svg";